import { createActionGroup, props } from '@ngrx/store';
import { LoadPropertyUploadsActionParams } from '../../models/property.model';
import { GetPropertyUploadsResponseModel } from '../../../shared/models/uploads/property-uploads.models';

interface LoadPropertyUploadsFailurePayload {
  error: unknown;
}

export const PropertyUploadActions = createActionGroup({
  source: 'PROPERTY',
  events: {
    'Load Property Uploads': props<LoadPropertyUploadsActionParams>(),
    'Load Property Uploads Success': props<GetPropertyUploadsResponseModel>(),
    'Load Property Uploads Failure': props<LoadPropertyUploadsFailurePayload>(),
  },
});
